import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Customer } from '../../shared-html-components/customer-search/customer-search.component';
import { singleCustomer, DeliveryAddress, ContactAddress } from '../../shared-html-components/customer-search/customer-search.component';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { findPhoneNumbersInText, parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';
import { NewCase } from 'app/cases/cases.component';
import { AddCustomer } from '../customer-models';
import { CompanyInformation } from '../../shared-html-components/details/models';
import * as api from '../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { DAWA } from 'app/shared/utilities/dawa';

@Component({
  selector: 'app-customer-address',
  templateUrl: './customer-address.component.html',
  styleUrls: ['./customer-address.component.css']
})
export class CustomerAddressComponent implements OnInit, OnDestroy, OnChanges {
  constructor(private httpClient: HttpClient, private sharedData: SharedDataService) { }
  @Input() step: string = 'final';
  @Output() stepChange = new EventEmitter();
  @Input() do: any;
  @Input() bootstrapSize: number = 3;
  @Input() customerId: string;
  @Input() deliveryId: string;
  @Input() contactId: string;
  @Input() notification: string;
  @Output() notificationChange = new EventEmitter();
  @Input() newCaseCustomer;
  @Input() deliveryToCase: AddCustomer;
  @Input() propertyId: string;
  @Input() resetCustomer: boolean = false;
  @Input() onlyCustomerAndInvoice:boolean = false;
  @Output() choose = new EventEmitter();
  @Output() com = new EventEmitter();
  @Output() update = new EventEmitter();
  companyInfo;
  who: string = '';
  allCustomers: Array<Customer>;
  output: Array<Customer>;
  propertyCustomers: Array<Customer>;
  startIndex = 0;
  endIndex = 50;
  scrollDistance = 1;
  scrollUpDistance = 2;
  throttle = 150;
  deliverySearch: string = '';
  contactSearch: string = '';
  test = parsePhoneNumberFromString;
  highlightedCustomer: string;

  options = new CustomerAddressOptions();
  convert = new CustomerAddressConvert();
  cvrSearchData;
  roles;
  hasProperty = false;
  searchAmount = 60;
  restrictAccess = false;
  subs: SubscriptionObject = {};

  ngOnInit() {
    // this.restrictAccess = !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PartnerOfferAccess');
    this.subs['companyInfo'] = this.sharedData.companyInformation().subscribe({
      next: (data: CompanyInformation) => this.companyInfo = data }
      );
    this.getCustomersPagination(this.startIndex, this.endIndex);
    document.addEventListener('click', (e) => { this.clickedOutsideOutput(e) });

    this.roles = JSON.parse(localStorage.getItem('guards') as string);
    if (this.roles != null) {
      if (this.roles.find(x => x.name == 'OperationsAndMaintenance')) { this.hasProperty = true }
    }
  }

  ngOnChanges(change: SimpleChanges) {
    if (!!change && !!change.do && change.do.currentValue != null) {
      if (!this.newCaseCustomer) {
        switch (change.do.currentValue) {
          case ('createCustomer'): {
            this.addCustomer();
            break
          }
          case ('chooseCustomer'): {
            if (this.options.leases == null || this.options.leases.length == 0) {
              this.stepChange.emit('final')
            }
            break
          }
          case ('chooseDelivery'): {
            if (this.options.delivery.deliveryId == null) {
              this.addNewDeliveryAddress(this.options.delivery);
            }
            else {
              this.editDeliveryAddress(this.options.delivery);
            }
            break
          }
          case ('chooseContact'): {
            if (this.options.contact.id == null) {
              this.addNewContactAddress(this.options.contact);
            }
            else {
              this.editContactAddress(this.options.contact);
            }
            break
          }
          case ('editCustomer'): {
            this.saveEditedCustomer();
            break
          }
          case ('back'): {
            break
          }
          case ('removeContact'): {
            this.options.contact = null;
            this.updateCustomer()
            break
          }
        }
      }
      else { }
      this.do = null;
      this.updateCustomer();
    }
    if (!!change && change.customerId && change.customerId.currentValue != null && change.customerId.currentValue != change.customerId.previousValue) {
      this.highlightedCustomer = change.customerId.currentValue;
      this.getCustomerById();
      this.getPropertyLeasesById();
    }
    if (!!change && change.notification && change.notification.currentValue != null) {
      this.options.notificationAddress = change.notification.currentValue;
    }
    if (!!change && change.deliveryId && change.deliveryId.currentValue != null && change.deliveryId.currentValue != change.deliveryId.previousValue && this.options.filteredDelivery.length != 0) {
      //console.log('deliveryId', change.deliveryId.currentValue)
      this.options.delivery = this.options.filteredDelivery.find(x => x.deliveryId == change.deliveryId.currentValue);
    }
    if (!!change && change.contactId && change.contactId.currentValue != null && change.contactId.currentValue != change.contactId.previousValue && this.options.filteredContacts.length != 0) {
      //console.log('contact', change.contactId.currentValue)
      this.options.contact = this.options.filteredContacts.find(x => x.id == change.contactId.currentValue)
    }
    if (!!change && change.newCaseCustomer && change.newCaseCustomer.currentValue != null) {
      //let o = this.options;
      let c = change.newCaseCustomer.currentValue;
      let res = this.convert.caseOptionAddresses(c);
      this.options.customer = res.customer;
      this.options.delivery = res.delivery;
      this.options.contact = res.contact;
      this.updateCustomer();
    }
    if (!!change && change.deliveryToCase && change.deliveryToCase.currentValue != null) {
      let c = new singleCustomer();
      c.customerName = this.deliveryToCase.customerName;
      c.invoiceName = this.deliveryToCase.invoiceName;
      c.customerAddress = this.deliveryToCase.customerAddress;
      c.invoiceAddress = this.deliveryToCase.invoiceAddress;
      c.customerZipCode = this.deliveryToCase.customerZipCode;
      c.invoiceZipCode = this.deliveryToCase.invoiceZipCode;
      c.customerCity = this.deliveryToCase.customerCity;
      c.invoiceCity = this.deliveryToCase.invoiceCity;
      c.customerPhone = this.deliveryToCase.customerTelephone;
      c.invoicePhone = this.deliveryToCase.invoiceTelephone;
      c.customerMobile = this.deliveryToCase.customerMobile;
      c.invoiceMobile = this.deliveryToCase.invoiceMobile;
      c.customerMail = this.deliveryToCase.customerEmail;
      c.invoiceEmail = this.deliveryToCase.invoiceEmail
      this.options.customer = c;
    }
  }

  ngOnDestroy() {
    document.removeEventListener('click', (e) => { this.clickedOutsideOutput(e) });
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
    this.output = null;
  }

  async search() {
    if (this.who != '') { this.getCustomerSearch() }
    else { this.getCustomersPagination(0, 80) }
  }

  getCustomersPagination(start, stop) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (this.propertyId == null) {
      this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomersPagination/' + start.toString() + '/' + stop.toString(), { headers }).subscribe(
        (data: Array<Customer>) => {
          this.output = data;
        }
      )
    } else {
      this.httpClient.get(api.jubloApi + 'api/PropertyLease/PropertyCustomers/' + this.propertyId, { headers }).subscribe(
      (data: Array<Customer>) => { 
        this.output = data;
        this.propertyCustomers = data;
      },
      (response) => { 
        console.log('Error!', response);
      },
      () => { }
    )
    }
    
  }

  getCustomerById() {
    if (this.highlightedCustomer != null && this.highlightedCustomer != this.options.customer.customerId) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomerById/' + this.highlightedCustomer, { headers }).subscribe(
        (data: singleCustomer) => {
          // console.log('customer data',this.highlightedCustomer, data)
          if(!!data){
            this.options.customer = data;
            this.options.filteredDelivery = data.addresses;
            this.options.filteredContacts = data.contactAddresse;
          }
        },
        (response) => { console.log('Customer could not be loaded', response) },
        () => {
          //console.log('Got customer', this.options, ' with deliveryId:', this.deliveryId, ' and contactId:', this.contactId)
          if (this.deliveryId != null) {
            let d = this.options.filteredDelivery.find(x => x.deliveryId == this.deliveryId);
            this.options.delivery = !!d ? d : this.options.delivery;
            if (!d) {
              this.options.delivery.deliveryId = null;
              this.addNewDeliveryAddress(this.options.delivery)
            };
            //console.log('found delivery', this.options.delivery)
            if (this.options.delivery != null) {
              this.options.customer.deliveryId == this.deliveryId;
            }
          }
          if (this.contactId != null) {
            let c = this.options.filteredContacts.find(x => x.id == this.contactId)
            this.options.contact = !!c ? c : this.options.contact;
            if (!c) {
              this.options.contact.id = null;
              this.addNewContactAddress(this.options.contact);
            }
          }
          this.do = 'getCustomer';
          if (!!this.options.notificationAddress) {
            this.validateNotification();
          }
          else { this.updateCustomer(); }
        }
      );
    }
  }

  getPropertyLeasesById() {
    if (this.highlightedCustomer != null) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomerPropertyLeases/' + this.highlightedCustomer, { headers }).subscribe(
        (data: any) => {
          this.options.leases = data;
          this.options.filteredLeases = data;
          this.updateCustomer();
        },
        (response) => { console.log('Error!', response) },
        () => { }
      )
    }
  }

  getCustomerSearch() {
    if (this.who != '') {
      if (this.propertyId == null) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
        this.httpClient.get(api.jubloApi + 'api/Website/Customer/GetCustomersSearch/' + this.who + '/' + this.searchAmount, { headers }).subscribe(
          (data: Array<Customer>) => {
            this.output = data
          }
        )
      } else {
        let who = this.who.toLowerCase();
        this.output = this.propertyCustomers.filter(x => 
          x.name != null && x.name.toLowerCase().match(who) ||
          x.customerNumber != null && x.customerNumber.toLowerCase().match(who) ||
          x.customerPhone != null && x.customerPhone.toLowerCase().match(who) ||
          x.customerMobile != null && x.customerMobile.toLowerCase().match(who) ||
          x.customerEmail != null && x.customerEmail.toLowerCase().match(who) ||
          x.customerAddress != null && x.customerAddress.toLowerCase().match(who));
      }

    } else {
      if (this.propertyId == null) {
        this.startIndex = 0; this.endIndex = 50;
        this.getCustomersPagination(this.startIndex, this.endIndex);
      } else {
        this.output = this.propertyCustomers;
      }
    }
  }

  showProperties() {
    let prop = [];
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PropertyLease/GetPropertyList', { headers }).subscribe(
      (data: any) => {
        prop = data.map(x => { return x.propertyCustomer.id });
        console.log(prop);
      }
    )
  }

  onScrollDown() {
    if (this.who == '') {
      this.startIndex += 25;
      this.endIndex += 25;
      this.getCustomersPagination(this.startIndex, this.endIndex);
    } else {
      this.searchAmount = this.searchAmount + 25
      this.getCustomerSearch();
    }
  }

  onChoice(id) {
    if(!!this.resetCustomer){
      this.options = new CustomerAddressOptions();
    }
    this.highlightedCustomer = id;
    this.getCustomerById();
    this.getPropertyLeasesById();
    if (id == null) {
      this.options.customer = new singleCustomer();
      this.stepChange.emit('newCustomer');
      this.step = 'newCustomer';
      this.updateCustomer();
    }
    this.choose.emit(id);
  }

  cvrSearch(event) {
    let useFirst = event.code == 'Enter' ? true : false;
    switch (this.companyInfo.companyLanguage) {
      case ('da-DK'): {
        this.httpClient.get('https://cvrapi.dk/api?search=' + this.options.customer.cvr + '&country=dk&token=8scfm3rphhdu3ardgv8ttev9fyqnammm').subscribe(
          (data: any) => {
            console.log(data)
            this.cvrSearchData = useFirst || !!data.error ? null : data;
            if (useFirst) {
              this.spreadSearchData(data);
            }
          },
          (response) => {
            console.log('Error from cvrapi');
            //this.options.customer.cvr = this.options.customer.cvr.slice(0, this.options.customer.cvr.length - 1)
          });
        break
      }
      case ('nn-NO'): {
        if (this.options.customer.cvr.length > 8) {
          this.httpClient.get('https://data.brreg.no/enhetsregisteret/api/enheter/' + this.options.customer.cvr).subscribe((data: any) => {
            let d = {
              vat: data.organisasjonsnummer,
              address: data.forretningsadresse.adresse[0],
              name: data.navn,
              city: data.forretningsadresse.poststed,
              zipcode: data.forretningsadresse.postnummer,
              phone: null,
              email: null
            }
            this.cvrSearchData = useFirst ? null : d;
            if (useFirst) {
              this.spreadSearchData(d);
            }
          },
            (response) => {
              console.log('Error from cvrapi');
              //this.options.customer.cvr = this.options.customer.cvr.slice(0, this.options.customer.cvr.length - 1)
            });
        }
        break
      }
      default: {  }
    }
  }

  spreadSearchData(data) {
    let c = this.options.customer;
    c.customerName = data.name;
    c.customerAddress = data.address;
    c.customerZipCode = data.zipcode;
    c.customerCity = data.city;
    c.customerPhone = data.phone;
    c.customerMobile = data.phone;
    c.customerMail = data.email;
    c.invoiceName = data.name;
    c.invoiceAddress = data.address;
    c.invoiceZipCode = data.zipcode;
    c.invoiceCity = data.city;
    c.invoicePhone = data.phone;
    c.invoiceMobile = data.phone;
    c.invoiceEmail = data.email;
    this.cvrSearchData = null;
  }

  copyInvoiceToCustomer() {
    this.options.customer.customerName = this.options.customer.invoiceName;
    this.options.customer.customerAddress = this.options.customer.invoiceAddress;
    this.options.customer.customerZipCode = this.options.customer.invoiceZipCode;
    this.options.customer.customerCity = this.options.customer.invoiceCity;
    this.options.customer.customerPhone = this.options.customer.invoicePhone;
    this.options.customer.customerMobile = this.options.customer.invoiceMobile;
    this.options.customer.customerMail = this.options.customer.invoiceEmail;
  }

  filterDelivery() {}

  communicate(infoObject) {
    this.step = infoObject.currentStep;
    this.com.emit(infoObject)
  }

  onDeliverySearch() {
    let s = this.deliverySearch.toLowerCase();
    this.options.filteredDelivery = this.options.customer.addresses.filter(
      x => x.customerName != null && x.customerName.toLowerCase().match(s) ||
        x.customerAddress != null && x.customerAddress.toLowerCase().match(s) ||
        x.customerCity != null && x.customerCity.toLowerCase().match(s) ||
        x.customerMail != null && x.customerMail.toLowerCase().match(s) ||
        x.customerZipCode != null && x.customerZipCode.match(s) ||
        x.customerPhone != null && x.customerPhone.match(s) ||
        x.customerMobile != null && x.customerMobile.match(s)
    )
  }

  onContactSearch() {
    let s = this.contactSearch.toLowerCase();
    this.options.filteredContacts = this.options.customer.contactAddresse.filter(
      x => x.name != null && x.name.toLowerCase().match(s) ||
        x.address != null && x.address.toLowerCase().match(s) ||
        x.city != null && x.city.toLowerCase().match(s) ||
        x.email != null && x.email.toLowerCase().match(s) ||
        x.zipCode != null && x.zipCode.match(s) ||
        x.phone != null && x.phone.match(s) ||
        x.mobile != null && x.mobile.match(s)
    )
  }

  chooseDelivery(x) {
    this.options.delivery = x;
    if (x.deliveryId == null) {
      this.addNewDeliveryAddress(x)
    }
    else {
      this.options.customer.deliveryId = x.deliveryId;
      this.updateCustomer();
    }
  }

  addNewDeliveryAddress(x: DeliveryAddress) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', {
      customerId: this.options.customer.customerId,
      name: x.customerName,
      address: x.customerAddress,
      zipCode: x.customerZipCode,
      city: x.customerCity,
      telephone: x.customerPhone,
      mobile: x.customerMobile,
      email: x.customerMail,
      ean: '',
      att: ''
    }, { headers }).subscribe(
      (data: string) => {
        this.options.customer.deliveryId = data;
        this.options.delivery.deliveryId = data;
        this.updateCustomer();
      },
      (response) => { },
      () => { }
    )
  }

  editDeliveryAddress(x: DeliveryAddress) {
    let phone: PhoneNumber = x.customerPhone != null && x.customerPhone != '' ? parsePhoneNumberFromString(x.customerPhone, this.companyInfo.companyLanguage.slice(3)) : null;
    let mobile: PhoneNumber = x.customerMobile != null && x.customerMobile != '' ? parsePhoneNumberFromString(x.customerMobile, this.companyInfo.companyLanguage.slice(3)) : null;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/Customer/EditDelivery/' + x.deliveryId, {
      "name": x.customerName,
      "address": x.customerAddress,
      "city": x.customerCity,
      "zipCode": x.customerZipCode,
      "mobile": mobile != null && mobile.number ? mobile.number : x.customerMobile,
      "phone": phone != null && phone.number ? phone.number : x.customerPhone,
      "email": x.customerMail,
      ean: x.ean,
      att: x.att
    }, { headers }).subscribe(
      val => { /*console.log('val', val);*/ },
      response => { console.log('response', response); },
      () => { }
    );
  }

  addNewContactAddress(x: ContactAddress) {
    let c = this.options.contact;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddContactAddress', {
      customerId: this.options.customer.customerId,
      name: c.name,
      address: c.address,
      city: c.city,
      zipCode: c.zipCode,
      telephone: c.phone,
      mobile: c.mobile,
      email: c.email,
      ean: c.ean,
      att: c.att,
      cvr: c.cvr,
      fax: c.fax
    }, { headers }).subscribe(
      (data: string) => {
        this.options.customer.contactId = data;
        this.options.contact.id = data;
        this.updateCustomer();
      },
      (response) => { },
      () => { }
    )
  }

  editContactAddress(x: ContactAddress) {
    let phone = x.phone != null && x.phone != '' ? parsePhoneNumberFromString(x.phone, this.companyInfo.companyLanguage.slice(3)).number : '';
    let mobile = x.mobile != null && x.mobile != '' ? parsePhoneNumberFromString(x.mobile, this.companyInfo.companyLanguage.slice(3)).number : '';
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/Customer/EditContact/' + x.id, {
      name: x.name,
      address: x.address,
      city: x.city,
      zipCode: x.zipCode,
      telephone: phone,
      mobile: mobile,
      email: x.email,
      ean: x.ean,
      att: x.att,
      cvr: x.cvr,
      fax: x.fax
    }, { headers }).subscribe(
      val => { /*console.log('val', val);*/ },
      response => { console.log('response', response); },
      () => { this.updateCustomer() }
    );
  }

  chooseContact(x) {
    this.options.customer.contactId = x.id;
    this.options.contact = x;
    this.updateCustomer();
  }

  newDelivery() {
    this.options.delivery = new DeliveryAddress();
    this.options.customer.deliveryId = null;
  }

  newContact() {
    this.options.contact = new ContactAddress();
    this.options.customer.contactId = null;
  }

  addCustomer() {
    let c = this.options.customer;
    let customerPhone = c.customerPhone != null && c.customerPhone != '' ? parsePhoneNumberFromString(c.customerPhone, this.companyInfo.companyLanguage.slice(3)).number : '';
    let invoicePhone = c.invoicePhone != null && c.invoicePhone != '' ? parsePhoneNumberFromString(c.invoicePhone, this.companyInfo.companyLanguage.slice(3)).number : '';
    let customerMobilePhone = c.customerMobile != null && c.customerMobile != '' ? parsePhoneNumberFromString(c.customerMobile, this.companyInfo.companyLanguage.slice(3)).number : '';
    let invoiceMobilePhone = c.invoiceMobile != null && c.invoiceMobile != '' ? parsePhoneNumberFromString(c.invoiceMobile, this.companyInfo.companyLanguage.slice(3)).number : '';
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Customer/AddCustomer', {
      companyId: this.companyInfo.id,
      number: null,
      customerName: c.customerName,
      customerAddress: c.customerAddress,
      customerZipCode: c.customerZipCode,
      customerCity: c.customerCity,
      customerTelephone: customerPhone,
      customerFax: '',
      customerEmail: c.customerMail,
      customerMobile: customerMobilePhone,
      invoiceName: c.invoiceName,
      invoiceAddress: c.invoiceAddress,
      invoiceZipCode: c.invoiceZipCode,
      invoiceCity: c.invoiceCity,
      invoiceTelephone: invoicePhone,
      invoiceFax: '',
      invoiceEmail: c.invoiceEmail,
      invoiceMobile: invoiceMobilePhone,
      customerGroupExternalId: null,
      cvr: c.cvr,
      att: c.att,
      ean: c.ean,
      customerRemarks: '',
      externalId: null
    }, { headers }).subscribe(
      (data: string) => {
        this.options.customer.customerId = data;
        if (this.options.delivery.deliveryId != null) {
          this.options.delivery.deliveryId = null;
          this.addNewDeliveryAddress(this.options.delivery)
        }

        if (this.options.contact.id != null) {
          this.options.contact.id = null;
          this.addNewContactAddress(this.options.contact)
        }

        //this.options.delivery = new DeliveryAddress();
        //this.options.delivery.deliveryId = null;
        //this.options.contact = new ContactAddress();
        this.updateCustomer();
      },
      (response) => { },
      () => { }
    )
  }

  saveEditedCustomer() {
    this.validateNotification();
    let c = this.options.customer;
    let customerPhone = c.customerPhone != null && c.customerPhone != '' ? parsePhoneNumberFromString(c.customerPhone, this.companyInfo.companyLanguage.slice(3)).number : '';
    let invoicePhone = c.invoicePhone != null && c.invoicePhone != '' ? parsePhoneNumberFromString(c.invoicePhone, this.companyInfo.companyLanguage.slice(3)).number : '';
    let customerMobilePhone = c.customerMobile != null && c.customerMobile != '' ? parsePhoneNumberFromString(c.customerMobile, this.companyInfo.companyLanguage.slice(3)).number : '';
    let invoiceMobilePhone = c.invoiceMobile != null && c.invoiceMobile != '' ? parsePhoneNumberFromString(c.invoiceMobile, this.companyInfo.companyLanguage.slice(3)).number : '';
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.put(api.jubloApi + 'api/Website/Customer/EditCustomer/' + c.customerId, {
      name: c.customerName,
      mobile: customerMobilePhone,
      phone: customerPhone,
      address: c.customerAddress,
      city: c.customerCity,
      zipCode: c.customerZipCode,
      email: c.customerMail,
      invoiceName: c.invoiceName,
      invoicePhone: invoicePhone,
      invoiceMobile: invoiceMobilePhone,
      invoiceAddress: c.invoiceAddress,
      invoiceCity: c.invoiceCity,
      invoiceZipCode: c.invoiceZipCode,
      invoiceEmail: c.invoiceEmail,
      att: c.att,
      cvr: c.cvr,
      ean: c.ean
    }, { headers }).subscribe(
      val => { this.do = null },
      response => { console.log('response', response); },
      () => { });
  }

  updateNotification(type) {
    switch (type) {
      case ('customer'): {
        this.options.notificationAddress = 'customer';
        this.notificationChange.emit(this.options.notificationAddress);
        this.validateNotification();
        break
      }
      case ('invoice'): {
        this.options.notificationAddress = 'invoice';
        this.notificationChange.emit(this.options.notificationAddress);
        this.validateNotification();
        break
      }
      case ('delivery'): {
        if (this.options.delivery.deliveryId != null) {
          this.options.notificationAddress = 'delivery';
          this.notificationChange.emit(this.options.notificationAddress);
          this.validateNotification();
        }
        break
      }
      case ('contact'): {
        if (this.options.contact.id != null) {
          this.options.notificationAddress = 'contact';
          this.notificationChange.emit(this.options.notificationAddress);
          this.validateNotification();
        }
        break
      }
    }
    //this.updateCustomer();
  }

  updateCustomer() {
    console.log('updating customer')
    this.update.emit(
      {
        customer: this.options.customer,
        delivery: this.options.delivery,
        contact: this.options.contact,
        notification: this.options.notificationAddress,
        notificationMailWarning: this.options.notificationMailWarning,
        notificationMobileWarning: this.options.notificationMobileWarning,
        leases: this.options.leases,
        action: this.do
      }
    )
  }

  async addressLookup(type) {
    if (this.companyInfo.companyLanguage == 'da-DK') {
      this.options.dawaSearchType = type;
      let o = this.options;
      let post = '', zip, address;
      switch (type) {
        case ('customer'): {
          zip = o.customer.customerZipCode;
          address = o.customer.customerAddress;
          ; break
        }
        case ('invoice'): {
          zip = o.customer.invoiceZipCode;
          address = o.customer.invoiceAddress;
          ; break
        }
        case ('delivery'): {
          zip = o.delivery.customerZipCode;
          address = o.delivery.customerAddress;
          ; break
        }
        case ('contact'): {
          zip = o.contact.zipCode != null ? o.contact.zipCode : '';
          address = o.contact.address != null ? o.contact.address : '';
          ; break
        }
      }
      if (!!zip && zip != '') { post = '&postnr=' + zip; }
      this.httpClient.get('https://dawa.aws.dk/adresser/autocomplete?q=' + address + post).subscribe((data: Array<DAWA>) => {
        //console.log(data)
        this.options.addressLookUp = data;
        //let road = new Set();
        //let roadNumber = [];
        //for (var i in data) {
        //  road.add(data[i].adresse.vejnavn);
        //  let vej = data[i].adresse.vejnavn;
        //  if (data[i].adresse.husnr) { vej = vej + ' ' + data[i].adresse.husnr; }
        //  if (data[i].adresse.etage) { vej = vej + ', ' + data[i].adresse.etage + '.'; }
        //  if (data[i].adresse.dør) { vej = vej + ' ' + data[i].adresse.dør + '.'; }
        //  roadNumber.push(vej);
        //}
        //if (road.size > 1) { this.options.addressLookUp = Array.from(road); this.options.roadSize = road.size }
        //if (road.size == 1 && roadNumber.length > 2) { this.options.addressLookUp = roadNumber; this.options.roadSize = 1 }
      })
    }
    //console.log(this.options.addressLookUp, this.options.dawaSearchType)
  }

  clickedOutsideOutput(event) {
    if (this.options.addressLookUp != null) {
      let box: any = document.getElementById('addressList').getBoundingClientRect();
      if (event.clientX > box.x + box.width || event.clientX < box.x) { this.options.addressLookUp = null }
      if (event.clientY > box.y + box.height || event.clientY < box.y) { this.options.addressLookUp = null }
    }
  }

  cityLookup(type) {
    if (this.companyInfo.companyLanguage == 'da-DK') {
      let o = this.options;
      let zip;
      switch (type) {
        case ('customer'): {
          zip = o.customer.customerZipCode;
          break
        }
        case ('invoice'): {
          zip = o.customer.invoiceZipCode;
          break
        }
        case ('delivery'): {
          zip = o.delivery.customerZipCode;
          break
        }
        case ('contact'): {
          zip = o.contact.zipCode;
          break
        }
      }
      zip = zip.toString();
      if (!!zip && zip.length == 4) {
        this.httpClient.get('https://dawa.aws.dk/postnumre/?nr=' + zip).subscribe((data: any) => {
          switch (type) {
            case ('customer'): {
              o.customer.customerCity = data[0].navn;
              break
            }
            case ('invoice'): {
              o.customer.invoiceCity = data[0].navn;
              break
            }
            case ('delivery'): {
              o.delivery.customerCity = data[0].navn;
              break
            }
            case ('contact'): {
              o.contact.city = data[0].navn;
              break
            }
          }
        });
      } 
    }
  }

  dawaToAddress(event, x: DAWA, where: string) {
    let o = this.options;
    let add = x.adresse.vejnavn;
      if (x.adresse.husnr) { add = add + ' ' + x.adresse.husnr; }
      if (x.adresse.etage) { add = add + ', ' + x.adresse.etage + '.'; }
      if (x.adresse.dør) { add = add + ' ' + x.adresse.dør + '.'; }
    switch (where) {
      case ('customer'): {
        o.customer.customerAddress = add;
        if (x.adresse.postnr != null && x.adresse.postnr != o.customer.customerZipCode) { o.customer.customerZipCode = x.adresse.postnr }
        if (x.adresse.postnrnavn != null && x.adresse.postnrnavn != o.customer.customerCity) { o.customer.customerCity = x.adresse.postnrnavn }
        break
      }
      case ('invoice'): {
        o.customer.invoiceAddress = add;
        if (x.adresse.postnr != null && x.adresse.postnr != o.customer.invoiceZipCode) { o.customer.invoiceZipCode = x.adresse.postnr }
        if (x.adresse.postnrnavn != null && x.adresse.postnrnavn != o.customer.invoiceCity) { o.customer.invoiceCity = x.adresse.postnrnavn }
        break
      }
      case ('delivery'): {
        o.delivery.customerAddress = add;
        if (x.adresse.postnr != null && x.adresse.postnr != o.delivery.customerZipCode) { o.delivery.customerZipCode = x.adresse.postnr }
        if (x.adresse.postnrnavn != null && x.adresse.postnrnavn != o.delivery.customerCity) { o.delivery.customerCity = x.adresse.postnrnavn }
        break
      }
      case ('contact'): {
        o.contact.address = add;
        if (x.adresse.postnr != null && x.adresse.postnr != o.contact.zipCode) { o.contact.zipCode = x.adresse.postnr }
        if (x.adresse.postnrnavn != null && x.adresse.postnrnavn != o.contact.city) { o.contact.city = x.adresse.postnrnavn }
        break
      }
    }
      this.options.addressLookUp = null;
      this.options.dawaSearchType = null;
  }

  getWidth() {
    return (100 / this.bootstrapSize).toString() + '%';
  }

  validateNotification() {
    // switch per notificationAddress. Check mail and phone number. Display warning if one is missing.
    // Also report it out of the component.
    switch (this.options.notificationAddress) {
      case ('delivery'): {
        this.options.notificationMailWarning = this.validateMail(this.options.delivery.customerMail);
        this.options.notificationMobileWarning = this.validateMobile(this.options.delivery.customerMobile);
        this.updateCustomer();
        ; break
      }
      case ('invoice'): {
        this.options.notificationMailWarning = this.validateMail(this.options.customer.invoiceEmail);
        this.options.notificationMobileWarning = this.validateMobile(this.options.customer.invoiceMobile);
        this.updateCustomer();
        ; break
      }
      case ('customer'): {
        this.options.notificationMailWarning = this.validateMail(this.options.customer.customerMail);
        this.options.notificationMobileWarning = this.validateMobile(this.options.customer.customerMobile);
        this.updateCustomer();
        ; break
      }
      case ('contact'): {
        this.options.notificationMailWarning = this.validateMail(this.options.contact.email);
        this.options.notificationMobileWarning = this.validateMobile(this.options.contact.mobile);
        this.updateCustomer();
        ; break
      }
    }
  }

  validateMail(mail) {
    if (mail == null || mail == '' || mail.split('@').length != 2) {
      return true
    }
    return false
  }

  validateMobile(mobile) {
    if (!mobile) return true;
    else if( !!mobile && parsePhoneNumberFromString(mobile, this.companyInfo.companyLanguage.slice(3)) == null) return true;
    return false
  }

  deliveryExists() {
    let d = this.options.delivery;
    if (!!this.deliveryId) { return true }
    else if (!!d && (!!d.customerName || !!d.customerAddress || !!d.customerCity || !!d.customerMail || !!d.customerPhone || !!d.customerMobile)) { return true }
    else {return false}
  }

  contactExists() {
    let d = this.options.contact;
    if (!!this.contactId) { return true }
    else if (!!d && (!!d.name || !!d.address || !!d.city || !!d.email || !!d.phone || !!d.mobile || !!d.cvr || !!d.att)) { return true }
    else { return false }
  }

  openAddressInGoogle(type){
    let a = this.addressByType(type);
    let url = [a.address, a.zipCode, a.city].join('+').replace(' ', '+');
    this.goGoogle(url);
  }

  openCityInGoogle(type){
    let a = this.addressByType(type);
    let url = [a.zipCode, a.city].join('+').replace(' ', '+');
    this.goGoogle(url);
  }

  addressByType(type){
    let o = this.options;
    switch(type){
      case 'invoice':{
        return {
          address: o.customer.invoiceAddress,
          zipCode: o.customer.invoiceZipCode,
          city: o.customer.invoiceCity
        };
        break
      }
      case 'customer':{
        return {
          address: o.customer.customerAddress,
          zipCode: o.customer.customerZipCode,
          city: o.customer.customerCity
        };
        break
      }
      case 'delivery':{
        return {
          address: o.delivery.customerAddress,
          zipCode: o.delivery.customerZipCode,
          city: o.delivery.customerCity
        };
        break
      }
      case 'contact':{
        return {
          address: o.contact.address,
          zipCode: o.contact.zipCode,
          city: o.contact.city
        };
        break
      }
    }
  }

  goGoogle(url){
    switch (this.companyInfo.companyLanguage) {
      case ('da-DK'): { window.open('https://www.google.dk/maps/place/' + url, '_blank') }
      case ('sv-SE'): { window.open('https://www.google.se/maps/place/' + url, '_blank') }
      case ('nn-NO'): { window.open('https://www.google.no/maps/place/' + url, '_blank') }
      default: { window.open('https://www.google.dk/maps/place/' + url, '_blank') }
    }
  }
}

export class CustomerAddressOptions {
  step: string;
  customer: singleCustomer = new singleCustomer();
  delivery: DeliveryAddress = new DeliveryAddress();
  contact: ContactAddress = new ContactAddress();
  lease: any;
  leases: Array<any>;
  notificationAddress: string = 'customer';
  notificationMailWarning: boolean = false;
  notificationMobileWarning: boolean = false;
  resetCustomer() {
    this.customer = new singleCustomer();
  }
  filteredDelivery = [];
  filteredContacts = [];
  filteredLeases = [];
  addressLookUp: Array<any>;
  roadSize = 10;
  dawaSearchType: string;
}

export class CustomerAddressConvert {
  caseOptionAddresses(a) {
    let da = !!a.deliveryAddress && !!a.deliveryAddress.name;
    let c = new singleCustomer();
    let d = new DeliveryAddress();
    let con = new ContactAddress();
    c.customerName = a.customer?.name;
    c.customerAddress = a.customer?.address;
    c.customerZipCode = a.customer?.zipCode;
    c.customerCity = a.customer?.city;
    c.customerMail = a.customer?.email;
    c.customerMobile = a.customer?.mobile;
    c.customerPhone = a.customer?.phone;
    c.invoiceName = a.invoice?.name;
    c.invoiceAddress = a.invoice?.address;
    c.invoiceZipCode = a.invoice?.zipCode;
    c.invoiceCity = a.invoice?.city;
    c.invoiceEmail = a.invoice?.email;
    c.invoiceMobile = a.invoice?.mobile;
    c.invoicePhone = a.invoice?.phone;
    d.customerName = da ? a.deliveryAddress.name : a.delivery?.name;
    d.customerAddress = da ? a.deliveryAddress.address : a.delivery?.address;
    d.customerZipCode = da ? a.deliveryAddress.zipCode : a.delivery?.zipCode;
    d.customerCity = da ? a.deliveryAddress.city : a.delivery?.city;
    d.customerMail = da ? a.deliveryAddress.email : a.delivery?.email;
    d.customerMobile = da ? a.deliveryAddress.mobile : a.delivery?.mobile;
    d.customerPhone = da ? a.deliveryAddress.phone : a.delivery?.phone;
    con.name = a.contact?.name;
    con.address = a.contact?.address;
    con.zipCode = a.contact?.zipCode;
    con.city = a.contact?.city;
    con.email = a.contact?.email;
    con.mobile = a.contact?.mobile;
    con.phone = a.contact?.phone;
    return { 
      customer: c,
      delivery: d,
      contact: con
    }
  }

  customerAddressToCaseAddress(c: singleCustomer) {
    return {
      customer: {
        customerId: c.customerId,
        name: c.customerName,
        address: c.customerAddress,
        zipCode: c.customerZipCode,
        city: c.customerCity,
        email: c.customerMail,
        phone: c.customerPhone,
        mobile: c.customerMobile,
        att: c.att,
        cvr: c.cvr
      },
      invoice: {
        id: c.customerId,
        name: c.invoiceName,
        address: c.invoiceAddress,
        zipCode: c.invoiceZipCode,
        city: c.invoiceCity,
        email: c.invoiceEmail,
        phone: c.invoicePhone,
        mobile: c.invoiceMobile
      }
    }
  }

  customerDeliveryAddressToCaseDeliveryAddress(d: DeliveryAddress) {
    return {
      id: d.deliveryId,
      name: d.customerName,
      address: d.customerAddress,
      zipCode: d.customerZipCode,
      city: d.customerCity,
      phone: d.customerPhone,
      mobile: d.customerMobile,
      email: d.customerMail
    }
  }
}
